import React from 'react';
import { motion } from 'framer-motion';
import { FaWhatsapp } from 'react-icons/fa';
import { pulse } from '../../utils/animations';
import { CONTACT } from '../../utils/constants';

const WhatsAppButton = () => {
  const handleClick = () => {
    window.open(CONTACT.whatsapp.url(), '_blank');
  };

  return (
    <motion.button
      onClick={handleClick}
      className="fixed bottom-6 right-6 z-50 w-16 h-16 bg-green-500 hover:bg-green-600 text-white rounded-full shadow-lg flex items-center justify-center transition-all duration-300"
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.9 }}
      animate={{
        boxShadow: [
          '0 4px 14px 0 rgba(34, 197, 94, 0.39)',
          '0 6px 20px 0 rgba(34, 197, 94, 0.5)',
          '0 4px 14px 0 rgba(34, 197, 94, 0.39)',
        ],
      }}
      transition={{
        duration: 2,
        repeat: Infinity,
        ease: 'easeInOut',
      }}
    >
      <FaWhatsapp className="text-3xl" />
    </motion.button>
  );
};

export default WhatsAppButton;
